import React from 'react';
import { Link } from 'react-router';
import Helmet from 'react-helmet';

class ForOFor extends React.Component {
  render() {
    return (
      <div className="bg-alt-light">
        <div className="text-center" style={{ padding: '150px 0' }}>
          <Helmet title={'Stránka neexistuje'} />
          <h1>Hopla, stránka sa nenašla!</h1>
          <Link to="/" className="btn btn-primary btn-lg">
            Späť do bezpečia
          </Link>
        </div>
      </div>
    );
  }
}

export default ForOFor;



// WEBPACK FOOTER //
// ./src/app/container/forOFor.js